import { createSlice } from '@reduxjs/toolkit';
import { loginUser, refreshAccessToken } from '@/store/auth/authThunks';

const initialState = {
  token: null,
  refreshToken: null,
  expiresAt: null,
  user: null,
  yritysId: null,
  status: 'idle',
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      state.token = null;
      state.refreshToken = null;
      state.expiresAt = null;
      state.user = null;
      state.yritysId = null;
      state.status = 'idle';
      state.error = null;
    },
    updateAuthTokens: (state, action) => {
      state.token = action.payload.token;
      state.refreshToken = action.payload.refreshToken;
      state.expiresAt = Date.now() + action.payload.expiresIn;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.token = action.payload.token;
        state.refreshToken = action.payload.refreshToken;
        state.expiresAt = Date.now() + action.payload.expiresIn;
        state.user = action.payload.user;
        state.yritysId = action.payload.yritysId;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.status = 'failed';
        if (action.payload === 'BACKEND_UNAVAILABLE') {
          state.error = 'Taustapalvelimeen ei saada yhteyttä, ylläpitoa on huomautettu. Yritä myöhemmin uudelleen.';
        }
        else {
          state.error = action.payload || action.error.message || 'Tuntematon virhe kirjautumisessa.';
        }
      });

    builder
      .addCase(refreshAccessToken.fulfilled, (state, action) => {
        state.token = action.payload.token;
        state.refreshToken = action.payload.refreshToken;
        state.expiresAt = Date.now() + action.payload.expiresIn;
      });
  },
});

export const { logout, updateAuthTokens } = authSlice.actions;
export default authSlice.reducer;
